import React from 'react';

import { ManagePayoutOrders } from 'features/payout-orders';

export const TechOperatorPayoutOrdersPage: React.FC = () => (
  <ManagePayoutOrders />
);
